const SKU_ITEMS_PUB_API = '/api/v2/apps/basic/sku/';
const RULE_GROUP = '/api/v2/apps/config/rulegroup/';
export const fetchUrl = {
  sku_search: `${SKU_ITEMS_PUB_API}sku_search`,
  sku_detail: `${SKU_ITEMS_PUB_API}sku_detail`,
  get_mtsku_attachment_list: `${SKU_ITEMS_PUB_API}get_mtsku_attachment_list`,
  sku_detail_update: `${SKU_ITEMS_PUB_API}sku_update`,
  sku_detail_history: `${SKU_ITEMS_PUB_API}search_sku_modify_log`,
  search_rule_group: `${RULE_GROUP}search_rule_group`,
  get_sku_volume: `${SKU_ITEMS_PUB_API}get_sku_volume`,
  get_new_sku_ado_upload_list: `${SKU_ITEMS_PUB_API}get_new_sku_ado_upload_list`,
};
